export const TABLE_DEFAULTS = {
    rowsPerTablePage: 10,
    maximumTableStringSize: 1024,
} as const;
